import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import $ from 'jquery';
import {hashHistory} from "react-router";
import {Route, Switch} from "react-router-dom";

import {
  toggleBathroomVisualizerOpen, setWindowWidth, setWindowHeight, setJobId, setCanvasDimensions, setJavascriptErrors
} from "../actions/actionFunctions";

import {loaderEnable} from "./ui/loaderView";

import Config, {IS_DASHBOARD_MESSAGING, IS_LIXIL_UI, IS_OFFLINE_MODE, IS_QKB_UI, POST_MESSAGES} from "../config";
import {
  browserIsSafari, isIOSDevice, isAndroid, isIframe, isIE, isChrome, isIphoneX, isFirefox
} from "../misc/helpers";
import {isFacebook} from "../misc/browsers";

import BathroomVisualizer from "./bvComponent/bathroomVisualizer";
import KitchenVisualizer from "./kvComponent/kitchenVisualizer";
import {getFabricatorSubscriptions, getJobIdPreset, saveQuoteFast} from '../api/server-api';
import {setMaterialsTutorialFinished, setVisualizerTutorialFinished} from "../actions/tutorialFunctions";
// import KvMasterVisualizer from "./kvMasterComponent/kvMasterVisualizer";
import KvSceneVisualizer from "./kvSceneComponent/kvSceneVisualizer";
import BvSceneVisualizer from "./bvSceneComponent/bvSceneVisualizer";
import FireplaceVisualizer from "./fireplace/fireplaceVisualizer";
import LookVisualizer from "./look/lookVisualizer";
import CommonVisualizer from "./commonVisualizer/commonVisualizer";
import BackToDashboardButton from "./common/dashboardButtons/backToDashboardButton";
import {setInitialVisualizerType, setLanguage} from "../actions/serverFunctions";
import Popups from "./popups";
import FakeOfflineSqft from "./sqft/fakeOfflineSqft";

import LookWhitePage from "./look/popups/lookWhitePage";
import LookPopups from "./look/popups/lookPopups";
// import PrintPopup from "./popups/printPopup/printPopup";
import {ROUTES} from "../routes";
import QKBRoutes from "../qkbRoutes";
import LookLockTutorial from "./look/popups/lockedOverlay/lookLockTutorial";
import {IS_PRODUCT_JOURNEY} from "../config";
import GroheComponents from "./look/grohe/groheComponents";
import LookComponents from "./look/lookComponents";
import WithLoginPostMessage from "./look/hocs/withLoginPostMessage";
import LookMessaging from "./look/lookMessaging";
import LookPolicyLinks from "./look/lookPolicyLinks";
import SquareFootageToolView from "./sqft/squareFootageToolView";
import SquareFootageToolPage from "./sqft/squareFootageToolPage";
import SquareFootageToolCabinetsIntro from "./sqft/squareFootageToolCabinetsIntro";
import SQFTPageAR from "./sqft/SQFTPageAR";
import SQFTPageARforTheSeparateModels from "./sqft/SQFTPageARforTheSeparateModels";
import {fixVisualizerType} from "../misc/visualizerSwitchingFunctions";
import laundryRoomLayout from "./commonVisualizer/core/laundryRoomLayout";
import {tryToSetUserFromUrl} from "../misc/userFunctions";
import {setSessionStorageItem} from "../misc/storageFunctions";
import {removeLoadingElements} from "../loadingLogic";
import ShoppingCartView from "./shoppingCart/shoppingCartView";

class BVQuotingTool extends Component {

  constructor(props) {
    super(props);
    this.resizeId = 0;
    this.resizeHeightId = 0;
    this.autoSaveTimerId = 0;
    this.state = {
      visMgmt: Config.isVisualizerManagement(),
    };
    if (this.state.visMgmt) {
      this.props.toggleBathroomVisualizerOpen(true);
      if (!window.location.href.includes("#/visualizer") && IS_QKB_UI) {
        hashHistory.push("visualizer");
      }
      setSessionStorageItem("cookieAccepted", true);
      document.kvConfig.visualizerOnly = true;
    }
  }

  async componentDidMount() {
    await this.setJobIdVisualizerType();
    this.props.setInitialVisualizerType(document.kvConfig.visualizerType);
    const url = new URL(window.location.href);
    if (JSON.parse(url.searchParams.get("dimensions"))) {
      alert(`${window.innerWidth} x ${window.innerHeight}`)
    }
    $(window).on('resize', this.handleResize);
    this.setMobileState();
    if (browserIsSafari()) {
      window.addEventListener("scroll", this.setGlobalHeight);
      document.body.classList.add('bv--safari');
      this.setGlobalHeight();
      setTimeout(() => {
        if (this.props.windowWidth < 991) {
          $("html, body").animate({scrollTop: 0}, 300);
        }
      }, 300)
    }
    if (document.kvConfig.jobId) { this.props.setJobId(document.kvConfig.jobId) }
    if (isIOSDevice()) { document.body.classList.add('bv--ios'); }
    if (isChrome()) { document.body.classList.add('bv--chrome'); }
    if (isIphoneX()) { document.body.classList.add('bv--iphoneX'); }
    if (isAndroid()) { document.body.classList.add('bv--android'); }
    if (isIframe()) { document.body.classList.add('bv--framed'); }
    if (isIE()) { document.body.classList.add('bv--ie'); }
    if (isFirefox()) { document.body.classList.add('bv--firefox'); }
    if (isFacebook) {
      document.body.classList.add('bv--facebook');
      this.props.toggleBathroomVisualizerOpen(true);
      if (!window.location.href.includes("visualizer") && IS_QKB_UI) {
        hashHistory.push("visualizer");
      }
    }
    this.getFabricatorData();
    await tryToSetUserFromUrl(url);
    this.props.setCanvasDimensions();
    try {
      window.sessionStorage
    } catch (ex) {
      this.props.setJavascriptErrors("sessionStorage");
    }
    try {
      window.localStorage
    } catch (ex) {
      this.props.setJavascriptErrors("localStorage");
    }

    if (window.location.href.indexOf('jobBoard=1') !== -1) {
      window.addEventListener("message", this.messageListening);
    }

    if (window.location.hash.includes("quote-design")) {
      removeLoadingElements("MainComponent");
    }

  }

  componentWillUnmount() {
    $(window).off('resize', this.handleResize);
    window.removeEventListener("message", this.messageListening);
    if (browserIsSafari()) {
      window.removeEventListener("scroll", this.handleHeightResize);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.bvOpened && !this.props.bvOpened && window.innerWidth < 991) { // workarounds to scroll BV to the middle of the screen
      document.querySelector('.base').classList.add('base--bv');
      $(window).trigger('setPinchZoom');
      window.setPinchZoom = true;
      // window.scrollTo(0, window.innerHeight/4);
      setTimeout(() => {
        document.body.classList.add('body--bv');  // add class after bv mobile blur click
        $(window).trigger('resize');
        $(window).resize();
        // window.scrollTo(0, window.innerHeight/4);
        // setTimeout(() => {
        //   window.scrollTo(0, window.innerHeight/4);
        // }, 0);
      }, 0)
    }
    if (nextProps.jobId && !this.props.jobId && !document.kvConfig.jobId) {
      this.enableAutoSaveQuote();
    } else if (!nextProps.jobId && this.props.jobId && !document.kvConfig.jobId) {
      this.disableAutoSaveQuote();
    }
  }

  setJobIdVisualizerType = async () => {
    if (document.kvConfig.jobId) {
      const jobResponse = await getJobIdPreset(document.kvConfig.jobId, this.props.editToken);
      if (jobResponse && jobResponse.data && jobResponse.data.records && jobResponse.data.records[0] && jobResponse.data.records[0].data) {
        const jobRecords = jobResponse.data.records;
        const bvState = jobResponse.data.records[0].data;
        const activeQuoteIndex = bvState.activeQuoteIndex || 0;
        if (jobRecords[activeQuoteIndex] && jobRecords[activeQuoteIndex].data && jobRecords[activeQuoteIndex].data.visualizerType
          && (jobRecords[activeQuoteIndex].data.visualizerType !== document.kvConfig.visualizerType)) {
          document.kvConfig.visualizerType = jobRecords[activeQuoteIndex].data.visualizerType;
          document.kvConfig.toolVersion = jobRecords[activeQuoteIndex].data.toolVersion;
          fixVisualizerType(); // set new bathroom or kitchen
          this.props.setCanvasDimensions(); // update canvas height and width (version 4 <> 5 switch)
          console.log('document.kvConfig.visualizerType changed after job load:', document.kvConfig.visualizerType);
        }
      }
    }
    return Promise.resolve();
  }

  messageListening = (event) => {
    if (event && event.data && event.data.action === POST_MESSAGES.setIframeLanguage) {
      this.props.setLanguage(event.data.payload.language)
    }
  };

  updateComponent = () => {
    this.forceUpdate()
  };

  getFabricatorData = async () => {
    loaderEnable();
    await getFabricatorSubscriptions();
    // loaderDisable(); // loader will be disabled in another requests
  };

  enableAutoSaveQuote = () => {
    const callRecursiveAutoSave = () => {
      saveQuoteFast();
      this.autoSaveTimerId = setTimeout(callRecursiveAutoSave, 20000); // auto save every 20 seconds
    };
    setTimeout(callRecursiveAutoSave, 20000); // first time
  };

  disableAutoSaveQuote = () => {
    clearTimeout(this.autoSaveTimerId);
  };

  handleResize = () => {
    clearTimeout(this.resizeId);
    this.resizeId = setTimeout(this.setMobileState, 300);
    // if (isIOSDevice() && isChrome()) {
    //   document.body.height = window.innerHeight;
    // }
  };

  handleHeightResize = () => {
    clearTimeout(this.resizeHeightId);
    this.resizeHeightId = setTimeout(this.setGlobalHeight, 300);
  };

  setMobileState = () => {
    this.props.setWindowWidth($(window).width());
    this.props.setWindowHeight($(window).height());
  };

  setGlobalHeight = () => {
    this.props.setWindowHeight(window.innerHeight + document.body.scrollTop);
  };

  getVisualizer = () => {

    if (!this.props.allowMainLoading || !this.props.fabricatorData.received
      || (document.kvConfig.initialFlowEnabled && !this.props.initialFlowFinished)) {
      return null
    }

    switch (document.kvConfig.visualizerType) {
      case "Kitchen":
      case "KV":
        return <KitchenVisualizer/>;
      case "Bathroom":
      case "BV":
        return <BathroomVisualizer/>;
      // case "kvMaster":
      //   return <KvMasterVisualizer/>;
      case "kvScene":
        return <KvSceneVisualizer/>;
      case "bvScene":
        return <BvSceneVisualizer/>;
      case "bvLook":
        return <LookVisualizer/>;
      case "Fireplace":
        return <FireplaceVisualizer/>;
      case "LaundryRoom":
        return <CommonVisualizer layout={laundryRoomLayout}/>;
      default:
        return null;
    }
  };

  render() {
    const {allowRouting, fabricatorData} = this.props;
    const fabricatorSettings = fabricatorData.settings;

    if (IS_DASHBOARD_MESSAGING) {
      return (
        <Fragment>
          {this.getVisualizer()}
          <Route path={ROUTES.shoppingcart} component={ShoppingCartView}/>
        </Fragment>
      )
    }

    return (
      <div className={"base"
        + (this.props.bvOpened ? " base--bv" : "")
        + (this.props.userPopupOpened ? " base--popup-opened" : "")
        + (this.state.visMgmt ? " base--without-buttons" : "")
        + (this.props.checkoutPopupVisible ? " checkout-visible" : "")
        + (" base-language--" + this.props.language)}>
        {IS_QKB_UI ? <QKBRoutes/> : null}
        <Switch>
          {/*<Route path={ROUTES.print}>*/}
          {/*  <PrintPopup/>*/}
          {/*</Route>*/}
          <Route path={ROUTES.sqft}>
            <SquareFootageToolPage />
          </Route>
          <Route path={ROUTES.sqftCabinetsIntro}>
            <SquareFootageToolCabinetsIntro/>
          </Route>
          <Route path={ROUTES.sqftCabinetsAR}>
            <SQFTPageAR/>
          </Route>
          <Route path={ROUTES.cabinetsAR}>
            <SQFTPageARforTheSeparateModels/>
          </Route>
        </Switch>
        { this.props.isSquareFootageEnabled ? <SquareFootageToolView/> : null}
        {fabricatorSettings.leadCapture && !IS_PRODUCT_JOURNEY ? <LookLockTutorial/> : null}
        <div className="room">
          {this.getVisualizer()}
          {IS_LIXIL_UI ? (
            <div className="main main--bv_scene">
              {IS_PRODUCT_JOURNEY
                ? <GroheComponents allowRouting={allowRouting}/>
                : <LookComponents allowRouting={allowRouting}/>}
              <WithLoginPostMessage>
                {(loginPostMessage) => <LookMessaging loginPostMessage={loginPostMessage}/>}
              </WithLoginPostMessage>
              <LookPolicyLinks/>
            </div>
          ) : null}
          {document.kvConfig.showBackToDashboard ? <BackToDashboardButton/> : null}
        </div>
        {IS_QKB_UI ? <Popups/> : (
          <Fragment>
            <LookWhitePage />
            <LookPopups/>
          </Fragment>
        )}
        {IS_OFFLINE_MODE ? <FakeOfflineSqft /> : null}
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  const {editToken, userPopupOpened, jobId, windowHeight} = store.userState;
  const {allowRouting, allowMainLoading, visualizerIsChanging, language} = store.serverState;

  return {
    cameFromPage: store.cartState.cameFromPage,
    bvOpened: store.bathroomVisualizerState.bvOpened,
    userPopupOpened,
    checkoutPopupVisible: store.cartState.checkoutPopupVisible,
    initialFlowFinished: store.initialFlowState.initialFlowFinished,
    fabricatorData: store.fabricatorState,
    editToken,
    jobId,
    windowHeight,
    allowRouting,
    allowMainLoading,
    isSquareFootageEnabled: store.sqftState.isSquareFootageEnabled,
    visualizerIsChanging,
    language,
  };
};

const mapDispatchToProps = {
  toggleBathroomVisualizerOpen,
  setWindowWidth,
  setWindowHeight,
  setJobId,
  setMaterialsTutorialFinished,
  setVisualizerTutorialFinished,
  setCanvasDimensions,
  setJavascriptErrors,
  setLanguage,
  setInitialVisualizerType,
}

export default connect(mapStateToProps, mapDispatchToProps)(BVQuotingTool);
